import PropTypes from "prop-types"
import React from "react"
import SmartLink from "../../../layout/SmartLink/SmartLink"
import { InlineText } from "../../../Typography/Typography"
import LineBreak from "../../../LineBreak/LineBreak"
import {
  BROWSE_SEARCH_PATH,
  generateGeoPathData,
  geoAreaLocationProviderDirectoryPath,
} from "../../../../utils/paths"

const getMoyoLink = (careServiceType, locationName) =>
  `${BROWSE_SEARCH_PATH}?care_type=care_home&location=${locationName}&care_provided[]=${careServiceType}`

const getCareServiceTypeLink = (
  careServiceType,
  locationName,
  geographicScale,
  districtType,
) =>
  geoAreaLocationProviderDirectoryPath(
    generateGeoPathData(
      geographicScale,
      locationName,
      "care_home",
      districtType,
    ),
    careServiceType,
  )

const careServiceTypeClickEvent = (careServiceType) => ({
  name: "SEO - Filtered Directory - Care Type Filter Clicked",
  properties: {
    "Care Specialism": careServiceType,
  },
})

const getCareServiceLink = (
  careServiceType,
  locationName,
  geographicScale,
  districtType,
) =>
  careServiceType === "dementia"
    ? getCareServiceTypeLink(
        careServiceType,
        locationName,
        geographicScale,
        districtType,
      )
    : getMoyoLink(careServiceType, locationName)

const CareServiceLink = ({
  locationName,
  serviceType,
  geographicScale,
  districtType,
}) => (
  <SmartLink
    to={getCareServiceLink(
      serviceType,
      locationName,
      geographicScale,
      districtType,
    )}
    chevron
    clickEvent={careServiceTypeClickEvent(serviceType)}
  >
    <InlineText brand>
      Search {serviceType} care in <LineBreak onDesktopOnly />
      {locationName}
    </InlineText>
  </SmartLink>
)

CareServiceLink.propTypes = {
  locationName: PropTypes.string.isRequired,
  serviceType: PropTypes.string.isRequired,
  geographicScale: PropTypes.string,
  districtType: PropTypes.string,
}

CareServiceLink.defaultProps = {
  geographicScale: undefined,
  districtType: undefined,
}

export default CareServiceLink
